export const fetchGameRecap = async (gamePk) => {
  const [contentRes, feedRes] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/content`),
    fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/feed/live`),
  ]);
  const content = contentRes.ok ? await contentRes.json() : null;
  const feed = feedRes.ok ? await feedRes.json() : null;
  return { content, feed };
};